import React, { createContext, useContext, useMemo, useState } from 'react';

const PageHeaderActionsContext = createContext(null);

export const PageHeaderActionsProvider = ({ children }) => {
  const [headerAction, setHeaderAction] = useState(null);
  const value = useMemo(() => ({ headerAction, setHeaderAction }), [headerAction]);

  return (
    <PageHeaderActionsContext.Provider value={value}>
      {children}
    </PageHeaderActionsContext.Provider>
  );
};

export const usePageHeaderActions = () => {
  const ctx = useContext(PageHeaderActionsContext);
  if (!ctx) {
    throw new Error('usePageHeaderActions must be used within PageHeaderActionsProvider');
  }
  return ctx;
};

export const useSetPageHeaderAction = (action) => {
  const { setHeaderAction } = usePageHeaderActions();

  React.useEffect(() => {
    setHeaderAction(action ?? null);
    return () => setHeaderAction(null);
  }, [action, setHeaderAction]);
};
